import React from 'react';

export default () => {
	return (
		<p>
			Zur Darstellung der Fachobjekte des Kartenthemas in der Karte werden weiße Symbole mit
			farbigem Hintergrund verwendet. Die dabei verwendeten Farben werden in der Titelzeile
			der Info-Box aufgegriffen. Zusätzlich werden dort die Informationen textlich
			zusammengefasst, die für die Kartendarstellung (Symbol und Hintergrundfarbe) relevant
			sind. Dort finden Sie also die Bedeutung des Symbols. Die verwendete Symbolik erklärt
			sich auf diese Weise selbst, sodass die Kartenanwendung keine klassische Legendengrafik
			benötigt.
		</p>
	);
};
